/**
 * App entrypoint: renders React App to DOM.
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { purgeLegacyGithubToken } from './store/projectPrefs';

// Clear a GitHub PAT persisted by a build that predated the in-memory-only
// policy. Runs before the app mounts so the credential is gone even if the user
// never opens Settings.
purgeLegacyGithubToken();

const rootElement = document.getElementById('root');
if (!rootElement) {
    throw new Error('Root element not found');
}

const root = ReactDOM.createRoot(rootElement);
root.render(
    <React.StrictMode>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </React.StrictMode>
);
